module.exports = __webpack_public_path__ + "static/media/import-url-document.8e73407d.svg";